import { Component, Renderer2 } from '@angular/core';
import * as L from 'leaflet';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { DtnService } from 'src/app/shared/service/dtn-service/dtn.service';
import { PortDetailsService } from 'src/app/shared/service/port-details/port-details.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { WebsocketService } from 'src/app/shared/service/websocket/websocket.service';
declare const windyInit: any;
@Component({
  selector: 'app-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.scss'],
})
export class MapViewComponent {
  private maxDays = 5;
  private hoursPerDay = 24;
  public maxTimeRange = this.maxDays * this.hoursPerDay;
  private map!: L.Map;
  private centroid: L.LatLngExpression = [50.4, 14.3];
  ships: any[] = [];
  showGrayFlag: boolean = false;
  public dates: string[] = [];
  timeRange: number = 24;
  currentDateIndex: number = 0;
  markers: L.Marker[] = [];
  weatherLayers: { [key: string]: L.TileLayer } = {};
  data: any;
  shipName: string = '';
  shipNameSuggestions: any[] = [];
  mapLoaded: boolean = false;
  private wsUrl = 'wss://sss589ql9g.execute-api.us-east-1.amazonaws.com/stage/';
  private uniqueRequestId: any;
  private messageSubscription!: Subscription;
  public voyageData: any;
  private currentMarker?: L.Marker;
  private routePolyline: L.Polyline | null = null;
  port: any;
  private circleMarkers: any[] = [];
  rowData: any;
  private simulationCache: { [key: string]: any } = {};

  playButton: boolean = false;
  private arrivalTimes: any[] = [];
  private animationFrameId!: number;
  public isAnimating: boolean = false;
  private currentIndex: number = 0;

  private savedLat: number | null = null;
  private savedLng: number | null = null;
  private savedSegmentIndex: number | null = null;
  private savedProgress: number = 0;
  showPopup: boolean = false;
  startDate: string = '';
  startTime: string = '';
  windy: any;
  pastVoyage: boolean = false;
  tosterMessage: boolean = false;
  periodicity: any = 3;
  userName: any;
  currentTime: any;
  animationInterval: any;
  pastRoutePolyline: any;

  private dtnLayers: { [key: string]: L.TileLayer } = {};
  private token: string | null = null;
  private baseLayer!: L.TileLayer;
  legendLabel: any;
  legend: boolean = false;
  legendImg: any;
  constructor(
    private requestFormService: RequestFormService,
    private renderer: Renderer2,
    private websocketService: WebsocketService,
    private portService: PortDetailsService,
    private ngxLoader: NgxUiLoaderService,
    private toster: ToastrService,
    private dtnService: DtnService
  ) { }

  ngOnInit() {
    this.userName = localStorage.getItem('username');
    this.initializeMap();
    this.loadData();
  }

  portDetails() {
    this.portService.getPortDetails().subscribe(
      (data: any) => {
        this.port = data;
      },
      (error) => console.error('Error fetching port details:', error)
    );
  }
  loadData() {
    this.requestFormService.getReports().subscribe((data) => {
      const selectedRadio = localStorage.getItem('selectedRadio');
      if (selectedRadio === 'myShips') {
        const selectedOperator = localStorage.getItem('selectedOperator');
        this.data = data.filter(
          (item: any) => item.eigerpic === selectedOperator
        );
      } else {
        this.data = data;
      }
      this.ships = this.data.filter(
        (element: any) =>
          element.status !== 'True' &&
          element.lat !== null &&
          element.long !== null &&
          element.lat !== '' &&
          element.long !== ''
      );
      if (this.ships.length > 0) {
        this.addMarkers();
        this.portDetails();
      }
    });
  }
  onShipSelected(event: any) {
    const shipName = event.option.value;
    const ship = this.ships.find((s) => s.ship === shipName);
    if (ship) {
      const { lat, long } = ship;
      this.map.flyTo([lat, long], 10, {
        animate: true,
        duration: 2,
      });
    } else {
      console.log('Ship not found');
    }
  }

  filterShipNames(event: any) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (filterValue.length > 0) {
      this.shipNameSuggestions = this.ships?.filter((item: any) =>
        item.ship.toLowerCase().includes(filterValue)
      );
    } else {
      this.shipNameSuggestions = [];
    }
  }
  initializeMap(): void {
    this.map = L.map('windy', {
      center: [34.553127, 18.048012],
      zoom: 4.5,
      zoomControl: true,
    });

    // Add Base map
    this.baseLayer = L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
      {
        maxZoom: 19,
      }
    ).addTo(this.map);

    this.map.createPane('weatherPane');
    this.map.createPane('referencePane');
    this.map.getPane('weatherPane')!.style.zIndex = '350';
    this.map.getPane('referencePane')!.style.zIndex = '380';

    L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
      {
        pane: 'referencePane',
        maxZoom: 19,
      }
    ).addTo(this.map);

    this.loadTokenAndAddLayers();

    setTimeout(() => {
      this.map.invalidateSize();
    }, 200);

    if (this.ships && this.ships.length > 0) {
      this.initMarkers();
    }

  }

  loadTokenAndAddLayers(forceReload = false) {
    if (this.token && !forceReload) {
      this.loadTileSetIdAndAddLayers();
      return;
    }

    this.dtnService.getToken().subscribe({
      next: (res) => {
        this.token = res.data.access_token;
        this.loadTileSetIdAndAddLayers();
      },
      error: (err) => console.error('DTN token fetch failed:', err),
    });
  }

  loadTileSetIdAndAddLayers() {
    if (!this.token) return;

    const layerId = 'fcst-onefx-wind-speed-contours';

    this.dtnService.getLatestTileSetId(layerId, this.token).subscribe({
      next: (tileSetId: any) => {
        this.addDtnLayers(tileSetId);
      },
      error: (err: any) => console.error('Failed to load tileSetId:', err),
    });
  }

  addDtnLayers(tileSetId: string) {
    if (!this.token) return;

    const token = this.token;

    const layerDefs: Record<string, string> = {
      'Wind Speed': `https://map.api.dtn.com/v2/tiles/fcst-onefx-wind-speed-contours/${tileSetId}/{z}/{x}/{y}?unit=metric&token=${token}`,
    };


    Object.values(this.dtnLayers).forEach((layer) =>
      this.map.removeLayer(layer)
    );
    this.dtnLayers = {};

    // create DTN layers
    Object.entries(layerDefs).forEach(([name, url]) => {
      const layer = L.tileLayer(url, {
        opacity: 0.65,
        pane: 'weatherPane',
        crossOrigin: true,
        noWrap: false,
      });
      this.dtnLayers[name] = layer;
    });

    // --- Layer Control ---
    const control = L.control
      .layers(
        { 'Base Map': this.baseLayer },
        {},
        { collapsed: false }
      )
      .addTo(this.map);

    Object.entries(this.dtnLayers).forEach(([name, layer]) => {
      control.addOverlay(layer, name);


      layer.on('add', () => {
        Object.entries(this.dtnLayers).forEach(([otherName, otherLayer]) => {
          if (otherName !== name && this.map.hasLayer(otherLayer)) {
            this.map.removeLayer(otherLayer);
          }
        });

        const legendInfo = this.legendMap[name];
        if (legendInfo) {
          this.legendLabel = legendInfo.label;
          this.legendImg = legendInfo.img;
          this.legend = true;
        }
      });


      layer.on('remove', () => {
        this.legend = false;
      });
    });
  }
  legendMap: Record<string, { label: string; img: string }> = {
    'Wind Speed': {
      label: 'Wind Speed (m/s)',
      img: '../../../../../assets/images/wind_speed_scale.png',
    },
    'Wave Height': {
      label: 'Wave Height (m)',
      img: 'assets/legends/wave-height.png',
    },
    Pressure: {
      label: 'Pressure (hPa)',
      img: 'assets/legends/pressure.png',
    },
  };


  addWeatherLayer(windyAPI: any) {
    setTimeout(() => {
      windyAPI.store.set('timestamp', Date.now());
    }, 500);
  }
  initMarkers(): void {
    this.markers.forEach((marker) => marker.remove());
    this.addMarkers();
  }
  addMarkers(): void {
    this.ships.forEach((res: any) => {
      const isVoyAvgSpeedValid =
        res.voyAvgSpeed !== null &&
        res.voyAvgSpeed !== '' &&
        res.voyAvgSpeed !== undefined;
      const difference = res.cpOrderedSpeed - res.voyAvgSpeed;
      const showRedFlag = isVoyAvgSpeedValid && difference > 0.5;
      const userName = localStorage.getItem('username');
      if (userName === 'Meraki - Operations') {
        this.showGrayFlag =
          res.voyAvgSpeed === null ||
          res.voyAvgSpeed === '' ||
          res.voyAvgSpeed === undefined;
      } else {
        this.showGrayFlag = false;
      }
      const shipIcon = this.createIcon(
        res.voyageType,
        this.removeShipPrefix(res.ship),
        this.map.getZoom(),
        showRedFlag,
        this.showGrayFlag
      );

      const marker = L.marker([res.lat, res.long], { icon: shipIcon }).addTo(
        this.map
      );
      this.markers.push(marker);
      const updatedAtDate = this.convertToUTC(res.updatedAt);
      const popup = `
          <b>Ship Name:</b> ${this.removeShipPrefix(res.ship.toUpperCase()) || 'NA'
        }<br>
          <b>Destination:</b> ${res.pTo || 'NA'}<br>
          <b>ETA(LT):</b> ${res.etaDate || 'NA'}<br>
          <b>Reported Wx:</b><br>
          <b>Wind(BF):</b> ${res.repWindBf || 'NA'}<br>
          <b>Swell Height:</b> ${res.repSwell || 'NA'}<br>
          <b>Cp Speed:</b> ${res.cpOrderedSpeed || 'NA'}<br>
          <b>Avg Speed(24hr):</b> ${res.repAvgSpeed || 'NA'}<br>
          <b>Avg Speed(Voyage):</b> ${res.voyAvgSpeed || 'NA'}<br><br>
          <b>Last Updated(UTC):</b> ${updatedAtDate}<br>
        `;

      marker.bindPopup(popup);

      marker.on('mouseover', () => {
        marker.openPopup();
      });
      marker.on('mouseout', () => {
        marker.closePopup();
      });
      marker.on('click', () => {
        this.tosterMessage = false;

        const shipId = res.imoNumber;
        if (this.currentMarker === marker) {
          this.playButton = true;
          this.ngxLoader.stop();
          this.stopRouteAnimation();

          this.removeCircleMarkers();
          this.showAllMarkers();
          this.currentMarker.setLatLng([res.lat, res.long]);
          this.removeRoute();
          this.currentMarker = undefined;
          return;
        }
        if (this.currentMarker) {
          this.ngxLoader.stop();
          this.map.removeLayer(this.currentMarker);
        }
        this.currentMarker = marker;
        this.currentMarker.addTo(this.map);
        this.hideOtherMarkers(marker);
        if (this.simulationCache[shipId]) {
          this.displayCachedRoute(this.simulationCache[shipId]);
        } else {
          this.ngxLoader.start();
          this.fetchAndCacheRouteData(res);
        }
      });
    });
  }
  encodeSignatureInUrl(url: string): string {
    const parsedUrl = new URL(url);
    const signature = parsedUrl.searchParams.get('Signature');

    if (!signature) return url;

    const encodedSignature = encodeURIComponent(signature);
    parsedUrl.searchParams.set('Signature', encodedSignature);

    return parsedUrl.toString();
  }

  fetchAndCacheRouteData(shipData: any) {
    this.websocketService
      .connect(this.wsUrl)
      .then(() => {
        this.sendVoyageSimulationRequest(shipData);
      })
      .catch((error: any) => {
        this.ngxLoader.stop();
        this.showAllMarkers();
        if (error.message === 'Port not found') {
          this.toster.warning('Destination Port coordinates not found');
        } else {
          this.toster.warning(
            'WebSocket connection failed. Please refresh and try again.'
          );
        }

        console.error('WebSocket connection failed:', error);
      });

    this.messageSubscription = this.websocketService
      .getMessages()
      .subscribe((message) => {
        const filteredMessage = message.replace(/NaN/g, '0');
        console.log(filteredMessage, 'filtered message');

        try {
          const parsedMessage = JSON.parse(filteredMessage);
          if (parsedMessage.response_id === this.uniqueRequestId) {
            const url = parsedMessage.url;
            const match = url.match(/[?&]Signature=([^&]+)/);
            const rawSignature = match ? match[1] : null;


            const containsSpecialChars = rawSignature
              ? /[+\/=]/.test(rawSignature)
              : false;

            const safeUrl = containsSpecialChars
              ? this.encodeSignatureInUrl(url)
              : url;
            this.requestFormService.getRouteData(safeUrl).subscribe(
              (res: any) => {
                this.ngxLoader.stop();
                this.toster.clear();
                this.voyageData = JSON.parse(res.replace(/NaN/g, 'null'));

                if (!this.simulationCache[shipData.imoNumber]) {

                  this.simulationCache[shipData.imoNumber] = [];
                }


                this.simulationCache[shipData.imoNumber].push(
                  JSON.parse(JSON.stringify(this.voyageData))
                );
                this.removeRoute();
                this.extractRouteFromVoyageData(this.voyageData);
              },
              (error: any) => {
                this.ngxLoader.stop();
                this.toster.warning('Refresh The Page And try Again');
                this.showAllMarkers();
              }
            );
          }
          if (parsedMessage.message === 'Internal server error') {
            this.toster.error('Internal server error');
            this.ngxLoader.stop();
            this.showAllMarkers();
          }
        } catch (error) {
          this.ngxLoader.stop();
          console.error('Error parsing JSON:', error);
        }
      });
  }

  displayCachedRoute(cachedVoyageData: any) {
    this.voyageData = cachedVoyageData[0];
    this.removeRoute();
    this.extractRouteFromVoyageData(this.voyageData);
  }

  createIcon(
    voyageType: string,
    shipName: string,
    zoomLevel: number,
    showRedFlag: boolean,
    showGrayFlag: boolean
  ): L.DivIcon {
    const size = this.getIconSize(zoomLevel);
    const color = voyageType === 'Ballast' ? 'blue' : '#7c2020';
    const flagHtml = showRedFlag
      ? '<i class="fa fa-flag" style="color: red; position: absolute; top: -52%; left: 86%;"></i>'
      : showGrayFlag
        ? '<i class="fa fa-flag" style="color: gray; position: absolute; top: -52%; left: 86%;"></i>'
        : '';
    return L.divIcon({
      className: `custom-icon ${voyageType.toLowerCase()}-icon`,
      html: `
        <div class="icon-wrapper">
          <i class="fa-sharp fa-solid fa-ship" style="color: ${color}; font-size: ${size}px;"></i>
          <span style="font-size: ${size}px;">${flagHtml}</span>
          <div class="ship-name">${shipName}</div>
        </div>`,
      iconSize: [size, size],
      iconAnchor: [size / 2, size],
      popupAnchor: [0, -size],
    });
  }

  getIconSize(zoomLevel: number): number {
    return Math.min(Math.max(zoomLevel * 2, 12), 40);
  }

  removeShipPrefix(shipName: string): string {
    if (!shipName) {
      return '';
    }
    return shipName.replace(/^(MV|MT)\s*/, '');
  }

  convertToUTC(updatedAtString: any) {
    if (!updatedAtString) return '';
    const date = new Date(updatedAtString);
    if (isNaN(date.getTime())) return '';
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = monthNames[date.getUTCMonth()];
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');

    return `${day} ${month} ${hours}:${minutes}`;
  }
  private routePoints: L.LatLngExpression[] = [];
  extractRouteFromVoyageData(voyageData: any): void {
    const data = voyageData.route;
    if (Array.isArray(data)) {
      this.routePoints = [];
      data.forEach((segment: any) => {
        const startPoint: L.LatLngExpression = [
          segment.startLat,
          segment.startLon,
        ];
        const endPoint: L.LatLngExpression = [segment.endLat, segment.endLon];

        this.routePoints.push(startPoint, endPoint);
      });
      this.plotRoute(this.routePoints, voyageData.route, new Date());
    } else {
      this.ngxLoader.stop();
      console.error('Invalid voyage data structure:', voyageData);
    }
  }

  plotRoute(
    routePoints: L.LatLngExpression[],
    data: any[],
    currentDate: Date
  ): void {
    if (routePoints.length > 0) {
      if (this.routePolyline) {
        this.map.removeLayer(this.routePolyline);
      }
      this.circleMarkers.forEach((marker) => this.map.removeLayer(marker));
      this.circleMarkers = [];

      const currentTime = currentDate.getTime();
      let currentSegmentIndex = -1;

      for (let i = 0; i < data.length - 1; i++) {
        const arrivalTimeStart = new Date(
          this.voyageData.animation_route[i]?.timestamp
        ).getTime();
        const arrivalTimeEnd = new Date(
          this.voyageData.animation_route[i + 1]?.timestamp
        ).getTime();

        if (currentTime >= arrivalTimeStart && currentTime <= arrivalTimeEnd) {
          currentSegmentIndex = i;
          break;
        }
      }

      console.log('Current Segment Index:', currentSegmentIndex);

      let pastRoute: L.LatLngExpression[] = [];
      let futureRoute: L.LatLngExpression[] = [];


      if (currentSegmentIndex !== -1) {
        pastRoute = routePoints.slice(0, currentSegmentIndex + 1);
        futureRoute = routePoints.slice(currentSegmentIndex + 1);
      } else {
        futureRoute = routePoints;
      }

      console.log('Past Route:', pastRoute);
      console.log('Future Route:', futureRoute);


      if (pastRoute.length > 1) {
        this.pastRoutePolyline = L.polyline(pastRoute, {
          color: '#545454',
          weight: 3,
          opacity: 0.7,
          dashArray: '8 8',
        }).addTo(this.map);
      }


      if (futureRoute.length > 1) {
        this.routePolyline = L.polyline(futureRoute, {
          color: 'blue',
          weight: 3,
          opacity: 0.7,
        }).addTo(this.map);
      }


      this.map.fitBounds(L.latLngBounds(routePoints));
      this.map.invalidateSize();


      routePoints.forEach((point, index) => {
        let marker: L.Marker | L.CircleMarker;

        if (index <= currentSegmentIndex) {

          const triangleIcon = L.divIcon({
            className: 'custom-diamond-marker',
            html: `<div style="
                    width: 15px;
                    height: 15px;
                    background-color: #545454;
                    transform: rotate(70deg);
                    position: relative;
                    top: 5px;
                    ">
                </div>`,
            iconSize: [20, 20],
          });

          marker = L.marker(point, { icon: triangleIcon }).addTo(this.map);
        } else {

          marker = L.circleMarker(point, {
            color: 'white',
            radius: 2,
            fillColor: 'white',
            fillOpacity: 1,
          }).addTo(this.map);
        }

        const segmentIndex = Math.floor(index / 2);
        const windData = data[segmentIndex] || {
          windDirection: 'N/A',
          windSpeed: 'N/A',
          windWaveDirection: 'N/A',
          windWaveHeight: 'N/A',
          swellHeight: 'N/A',
          swellDirection: 'N/A',
          adjustedSpeed: 'N/A',
          arrivalTimeCPSpeed: 'N/A',
        };

        const popupContent = `  
                <b>Ship Name:</b> ${this.removeShipPrefix(this.rowData.ship) || 'NA'
          }<br>
                <b>Destination:</b> ${this.rowData.pTo || 'NA'}<br>
                <b>ETA(LT) At Wave Point:</b> ${windData.arrivalTimeCPSpeed || 'NA'
          }<br>
                 <b>ETA(LT) At Destination:</b> ${data[data.length - 1].arrivalTimeCPSpeed || 'NA'
          }<br>
                <b>Reported Wx:</b><br>
                <b>Wind Speed:</b> ${windData.windSpeed || 'NA'} knots<br>
                <b>Wind Direction:</b> ${windData.windDirection}°<br>
                <b>Swell Height:</b> ${windData.swellHeight || 'NA'}<br>
                <b>Swell Direction:</b> ${windData.swellDirection || 'NA'}<br>
                <b>Speed:</b> ${windData.adjustedSpeed || 'NA'}<br>
            `;

        marker.bindPopup(popupContent);

        marker.on('mouseover', () => {
          marker.openPopup();
        });

        marker.on('mouseout', () => {
          marker.closePopup();
        });

        this.circleMarkers.push(marker);
      });

      this.moveShipToCurrentDatePosition(new Date(currentTime));
      this.ngxLoader.stop();
    } else {
      this.ngxLoader.stop();
      console.error('No route points to plot:', routePoints);
    }
  }

  removeRoute(): void {
    if (this.routePolyline && this.playButton) {

      console.log('Removing route:', this.routePolyline);
      if (this.routePolyline) {
        this.map.removeLayer(this.routePolyline);
        this.routePolyline = null;
      }
      if (this.pastRoutePolyline) {
        this.map.removeLayer(this.pastRoutePolyline);
        this.pastRoutePolyline = null;
      }

      console.log('Route removed, current routePolyline:', this.routePolyline);
    } else {
      console.log('No route to remove');
    }
  }
  showAllMarkers(): void {
    this.markers.forEach((marker) => {
      this.map.addLayer(marker);
    });
  }
  hideOtherMarkers(exceptMarker: L.Marker): void {
    this.markers.forEach((marker) => {
      if (marker !== exceptMarker) {
        this.map.removeLayer(marker);
      }
    });
  }
  removeCircleMarkers(): void {
    this.circleMarkers.forEach((circleMarker) => {
      this.map.removeLayer(circleMarker);
    });
    this.circleMarkers = [];
  }
  sendVoyageSimulationRequest(data: any): void {
    const generateUniqueId = (): string => {
      return (
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
      );
    };

    const formatDate = (date: Date): string => {
      const padZero = (num: number): string => (num < 10 ? '0' : '') + num;

      const year = date.getFullYear();
      const month = padZero(date.getMonth() + 1);
      const day = padZero(date.getDate());
      const hours = padZero(date.getHours());
      const minutes = padZero(date.getMinutes());
      const seconds = padZero(date.getSeconds());

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
    };
    const portCoordinates = this.findPortCoordinates(data.pTo);
    const cpCons = parseFloat(data.cpFuel) || 0;
    const cospDate = new Date(data.time_of_report);
    const requestData = {
      start_lat: data.lat,
      start_lon: data.long,
      ship_length: data.ship_length,
      ship_breadth: data.ship_breadth,
      wind_drag_coefficient: data.wind_drag_coefficient,
      air_density: data.air_density,
      empirical_constant: data.empirical_constant,
      power_inp: data.power_inp,
      windage_area: data.windage_area,
      end_lat: portCoordinates.latitude,
      end_lon: portCoordinates.longitude,
      cp_speed: parseFloat(data.cpOrderedSpeed) || 0,
      cp_cons: cpCons,
      imo: data.imoNumber,
      draft: 0,
      segment_length: 100,
      weather_source: 'SG',
      starttime: formatDate(cospDate),
      request_id: generateUniqueId(),
      periodicity: this.periodicity,
    };

    console.log(data, 'Data');
    this.uniqueRequestId = requestData.request_id;
    this.websocketService.sendMessage(requestData);
    this.rowData = data;
  }
  findPortCoordinates(portName: string) {
    const ports = this.port?.data ?? [];

    const port = ports.find((p: any) => {
      const name = p.port_name?.split('_')[0]?.trim().toLowerCase();
      return name === portName.trim().toLowerCase();
    });

    if (port) {
      return { latitude: port.latitude, longitude: port.longitude };
    } else {
      this.ngxLoader.stop();
      throw new Error('Port not found');
    }
  }

  moveShipToCurrentDatePosition(currentDate: any): void {
    this.currentTime = currentDate;
    this.pastVoyage = false;
    this.arrivalTimes = this.voyageData.animation_route.map(
      (_: any, index: any) => {
        const routeData = this.voyageData.animation_route[index];
        return routeData?.timestamp ? new Date(routeData.timestamp) : null;
      }
    );

    const currentTime = currentDate.getTime();
    let currentSegmentIndex = -1;
    let progress = 0;

    for (let i = 0; i < this.arrivalTimes.length - 1; i++) {
      const arrivalTimeStart = this.arrivalTimes[i]?.getTime();
      const arrivalTimeEnd = this.arrivalTimes[i + 1]?.getTime();

      if (
        arrivalTimeStart &&
        arrivalTimeEnd &&
        currentTime >= arrivalTimeStart &&
        currentTime <= arrivalTimeEnd
      ) {
        currentSegmentIndex = i;
        const totalSegmentTime = arrivalTimeEnd - arrivalTimeStart;
        const elapsedSegmentTime = currentTime - arrivalTimeStart;
        progress = elapsedSegmentTime / totalSegmentTime;
        break;
      }
      const allPast = this.arrivalTimes
        .filter((arrivalTime) => arrivalTime !== null)
        .every((arrivalTime) => currentTime > arrivalTime!.getTime());

      if (allPast) {
        if (!this.tosterMessage) {
          this.toster.warning('This Voyage Reached Its Destination');
          this.tosterMessage = true;
        }
        this.pastVoyage = true;
        const lastPoint = this.routePoints[
          this.routePoints.length - 1
        ] as L.LatLngTuple;
        this.currentMarker?.setLatLng(lastPoint);

        return;
      }
    }
    const start = this.routePoints[currentSegmentIndex] as L.LatLngTuple;
    const end = this.routePoints[currentSegmentIndex + 1] as L.LatLngTuple;

    const currentLat = start[0] + progress * (end[0] - start[0]);
    const currentLng = start[1] + progress * (end[1] - start[1]);
    this.currentMarker?.setLatLng([currentLat, currentLng]);
  }

  startRouteAnimation(): void {
    this.routePoints = this.voyageData.animation_route.map((point: any) => [
      point.latitude,
      point.longitude,
    ]);


    if (this.routePoints.length > 0) {

      if (this.routePolyline) {
        this.removeRoute();
        this.removeCircleMarkers();
        this.routePolyline = L.polyline(this.routePoints, {
          color: 'blue',
        }).addTo(this.map);
      }
    }

    if (this.routePoints.length === 0) {
      console.error('No route points available for animation.');
      return;
    }

    if (this.pastVoyage) {
      return;
    }


    this.arrivalTimes = this.voyageData.animation_route.map(
      (_: any, index: string | number) => {
        const arrivalTime = new Date(
          this.voyageData.animation_route[index]?.timestamp
        );
        return arrivalTime;
      }
    );


    if (!this.currentMarker) {
      if (this.savedLat !== null && this.savedLng !== null) {

        this.currentMarker = L.marker([this.savedLat, this.savedLng]).addTo(
          this.map
        );
      } else {

        this.currentMarker = L.marker(this.routePoints[0]).addTo(this.map);
      }
    } else if (!this.isAnimating && this.savedSegmentIndex === null) {

      this.currentMarker.setLatLng(this.routePoints[0]);
    }

    this.isAnimating = true;


    const startIndex = this.savedSegmentIndex ?? 0;
    this.animateAlongRoute();
  }

  private animationTimeout: any;

  animateAlongRoute(): void {
    if (!this.isAnimating) {
      return;
    }

    const incrementTime = 2 * 60 * 60 * 1000;
    const timeInterval = 340;

    this.animationInterval = setInterval(() => {
      this.currentTime = new Date(this.currentTime).getTime() + incrementTime;


      this.updateInterpolatedPosition(new Date(this.currentTime));

      if (this.pastVoyage) {
        clearInterval(this.animationInterval);
        this.animationInterval = null;
      }
    }, timeInterval);
  }

  updateInterpolatedPosition(currentDate: Date): void {
    this.currentTime = currentDate;


    const animationRoute = this.voyageData.animation_route;

    const currentTime = currentDate.getTime();
    let currentSegmentIndex = -1;
    let progress = 0;

    for (let i = 0; i < animationRoute.length - 1; i++) {
      const startTime = new Date(animationRoute[i].timestamp).getTime();
      const endTime = new Date(animationRoute[i + 1].timestamp).getTime();

      if (currentTime >= startTime && currentTime <= endTime) {
        currentSegmentIndex = i;

        const totalSegmentTime = endTime - startTime;
        const elapsedSegmentTime = currentTime - startTime;

        progress = elapsedSegmentTime / totalSegmentTime;
        break;
      }
    }

    if (currentSegmentIndex === -1) {
      const lastPoint = animationRoute[animationRoute.length - 1];
      if (currentTime > new Date(lastPoint.timestamp).getTime()) {
        if (!this.tosterMessage) {
          this.toster.warning('This Voyage Reached Its Destination');
          this.tosterMessage = true;
        }
        this.pastVoyage = true;

        this.currentMarker?.setLatLng([
          lastPoint.latitude,
          lastPoint.longitude,
        ]);
      }
      return;
    }

    const startPoint = animationRoute[currentSegmentIndex];
    const endPoint = animationRoute[currentSegmentIndex + 1];

    const interpolatedLat =
      startPoint.latitude +
      progress * (endPoint.latitude - startPoint.latitude);
    const interpolatedLng =
      startPoint.longitude +
      progress * (endPoint.longitude - startPoint.longitude);


    this.currentMarker?.setLatLng([interpolatedLat, interpolatedLng]);
  }

  stopRouteAnimation(): void {
    this.isAnimating = false;
    console.log('Animation stopped');


    const currentPos = this.currentMarker?.getLatLng();
    if (currentPos) {
      this.savedLat = currentPos.lat;
      this.savedLng = currentPos.lng;
    }


    const segmentIndex = this.getSegmentIndexFromPosition(currentPos);
    this.savedSegmentIndex = segmentIndex;
    this.savedProgress = this.getProgressForSegment(segmentIndex, currentPos);


    if (this.animationInterval) {
      clearInterval(this.animationInterval);
      this.animationInterval = null;
    }
  }


  private getSegmentIndexFromPosition(position: L.LatLng | undefined): number {
    if (!position) return 0;

    for (let i = 0; i < this.routePoints.length - 1; i++) {
      const start = L.latLng(this.routePoints[i] as L.LatLngTuple);
      const end = L.latLng(this.routePoints[i + 1] as L.LatLngTuple);

      const distanceStart = this.getDistance(position, start);
      const distanceEnd = this.getDistance(position, end);


      if (distanceStart < distanceEnd) {
        return i;
      }
    }

    return this.routePoints.length - 2;
  }

  private getDistance(pointA: L.LatLng, pointB: L.LatLng): number {
    return pointA.distanceTo(pointB);
  }


  private getProgressForSegment(
    segmentIndex: number,
    position: L.LatLng | undefined
  ): number {
    if (!position) return 0;

    const start = L.latLng(this.routePoints[segmentIndex] as L.LatLngTuple);
    const end = L.latLng(this.routePoints[segmentIndex + 1] as L.LatLngTuple);

    const segmentLength = this.getDistance(start, end);
    const distanceTraveled = this.getDistance(start, position);

    return distanceTraveled / segmentLength;
  }

  ngOnDestroy(): void {
    cancelAnimationFrame(this.animationFrameId);
    if (this.messageSubscription) {
      this.messageSubscription.unsubscribe();
    }
    this.websocketService.close();
  }
}
